<div *ngIf="isLoading" class="overlay"></div>
<div *ngIf="isLoading" class="loader"></div>
<div class="example-inner">
  <div class="container">
  <div class="header">
    <button mat-raised-button 
          color="primary" 
          class="dashboard-button" 
          routerLink="/products">
    <mat-icon>dashboard</mat-icon>
    <span>Stock Dashboard</span>
    </button>
    <h1 class="page-title" >List Stock</h1>
</div>
  <kendo-tabstrip>
    <kendo-tabstrip-tab title="All Products" [selected]="true">
      <ng-template kendoTabContent>
      <span><h1>Stock Status</h1></span>
      <!--<button style="float: none;" type="button" mat-raised-button (click)="getAll()" color="warn">All Products</button>
      <button style="float: none;" type="button" mat-raised-button (click)="getAlerts()" color="warn">Alerts</button>
      <button style="float: none;" type="button" mat-raised-button (click)="getWarnings()" color="warn">Warnings</button> -->
      <kendo-grid
        [data]="gridData | async"
        [height]="650"
        [pageSize]="gridState.take"
        [skip]="gridState.skip"
        [sort]="gridState.sort"
        [sortable]="true"
        [pageable]="true"
        scrollable="none"
        [filterable]="true"
        [filter]="gridState.filter"
        (dataStateChange)="dataStateChange($event)"
        (edit)="updateJewellery($event)"
        (add)="createJewellery()"
      >
        <ng-template kendoGridToolbarTemplate>
          <button kendoGridAddCommand>Add new</button>
        </ng-template>
        <kendo-grid-column field="title" title="Title"></kendo-grid-column>
        <kendo-grid-column field="supplierName" title="Supplier"></kendo-grid-column>
        <kendo-grid-column field="store" title="Store"></kendo-grid-column>
        <kendo-grid-column field="costPrice" title="Cost Price"></kendo-grid-column>
        <kendo-grid-column field="stockCount" title="Stock Count"></kendo-grid-column>
        <kendo-grid-column field="stockAlert" title="Stock Alert"></kendo-grid-column>
        <kendo-grid-column field="stockWarning" title="Stock Warning"></kendo-grid-column>
        <kendo-grid-command-column title="Actions" [width]="220">
          <ng-template kendoGridCellTemplate>
            <button kendoGridEditCommand [primary]="true">Edit</button>
            <button kendoGridRemoveCommand>Delete</button>
          </ng-template>
        </kendo-grid-command-column>
      </kendo-grid>
    </ng-template>
    </kendo-tabstrip-tab>
    <kendo-tabstrip-tab title="Alerts">
      <ng-template kendoTabContent>
      <span><h1>Stock Alerts</h1></span>
      <kendo-grid
        [data]="gridDataAlert | async"
        [height]="650"
        [pageSize]="gridStateAlert.take"
        [skip]="gridStateAlert.skip"
        [sort]="gridStateAlert.sort"
        [sortable]="true"
        [pageable]="true"
        scrollable="none"
        (dataStateChange)="dataStateChangeAlert($event)"
        (edit)="reOrderProduct($event)"
      >
        <kendo-grid-column field="title" title="Title"></kendo-grid-column>
        <kendo-grid-column field="supplierName" title="Supplier"></kendo-grid-column>
        <kendo-grid-column field="store" title="Store"></kendo-grid-column>
        <kendo-grid-column field="costPrice" title="Cost Price"></kendo-grid-column>
        <kendo-grid-column field="stockCount" title="Stock Count"></kendo-grid-column>
        <kendo-grid-column field="stockAlert" title="Stock Alert"></kendo-grid-column>
        <kendo-grid-column field="stockWarning" title="Stock Warning"></kendo-grid-column>
        <kendo-grid-command-column title="Actions" [width]="220">
          <ng-template kendoGridCellTemplate>
            <button kendoGridEditCommand [primary]="true">ReOrder</button>
          </ng-template>
        </kendo-grid-command-column>
      </kendo-grid>
      </ng-template>
    </kendo-tabstrip-tab>
    <kendo-tabstrip-tab title="Warnings">
      <ng-template kendoTabContent>
      <span><h1>Stock Warnings</h1></span>
      <kendo-grid
        [data]="gridDataWarning | async"
        [height]="650"
        [pageSize]="gridStateWarning.take"
        [skip]="gridStateWarning.skip"
        [sort]="gridStateWarning.sort"
        [sortable]="true"
        [pageable]="true"
        scrollable="none"
        (dataStateChange)="dataStateChangeWarning($event)"
        (edit)="reOrderProduct($event)"
        (add)="createJewellery()"
      >
        <kendo-grid-column field="title" title="Title"></kendo-grid-column>
        <kendo-grid-column field="supplierName" title="Supplier"></kendo-grid-column>
        <kendo-grid-column field="store" title="Store"></kendo-grid-column>
        <kendo-grid-column field="costPrice" title="Cost Price"></kendo-grid-column>
        <kendo-grid-column field="stockCount" title="Stock Count"></kendo-grid-column>
        <kendo-grid-column field="stockAlert" title="Stock Alert"></kendo-grid-column>
        <kendo-grid-column field="stockWarning" title="Stock Warning"></kendo-grid-column>
        <kendo-grid-command-column title="Actions" [width]="220">
          <ng-template kendoGridCellTemplate>
            <button kendoGridEditCommand [primary]="true">ReOrder</button>
          </ng-template>
        </kendo-grid-command-column>
      </kendo-grid>
      </ng-template>
    </kendo-tabstrip-tab>
    
  </kendo-tabstrip>
</div>
</div>